/** 生产管理 canonical 入口 */
export const PRODUCTION_HUB = '/production';
export const LEGACY_PRODUCTION_PREFIX = '/my-plant-protection';

/** 方案 3.2–3.4 及全量迁移：旧路径后缀 → 新路径（不含 query） */
const EXACT_SUFFIX_MAP = {
  '': PRODUCTION_HUB,
  '/my-farm': `${PRODUCTION_HUB}/land`,
  '/farm-insight-hub': `${PRODUCTION_HUB}/farm-insight-hub`,
  '/land-management-hub': `${PRODUCTION_HUB}/land/hub`,
  '/land-management': `${PRODUCTION_HUB}/land/assets`,
  '/land-asset-info': `${PRODUCTION_HUB}/land/assets`,
  '/asset-management': `${PRODUCTION_HUB}/land/asset-management`,
  '/smart-irrigation-hub': `${PRODUCTION_HUB}/field-work/irrigation`,
  '/planted-crops': `${PRODUCTION_HUB}/crop/plans`,
  '/planting-plan-manage': `${PRODUCTION_HUB}/crop/planted`,
  '/planting-plan': `${PRODUCTION_HUB}/crop/planted`,
  '/planting-planning': `${PRODUCTION_HUB}/crop/planted`,
  '/growth-cycle': `${PRODUCTION_HUB}/crop/growth-cycle`,
  '/growth-budget': `${PRODUCTION_HUB}/crop/growth-budget`,
  '/warning-analysis': `${PRODUCTION_HUB}/crop/warning-analysis`,
  '/material-estimate': `${PRODUCTION_HUB}/crop/material-estimate`,
  '/production-planning': `${PRODUCTION_HUB}/crop/planted`,
  '/planning-statistics': `${PRODUCTION_HUB}/crop/planning-statistics`,
  '/crop-global-distribution': `${PRODUCTION_HUB}/crop/global-distribution`,
  '/crop-growth-comparison': `${PRODUCTION_HUB}/crop/growth-comparison`,
  '/field-work-overview': `${PRODUCTION_HUB}/field-work`,
  '/field-work-ledger': `${PRODUCTION_HUB}/field-work/ledger`,
  '/field-management': `${PRODUCTION_HUB}/field-work/plans`,
  '/field-plan-management': `${PRODUCTION_HUB}/field-work/plan-manage`,
  '/field-operations': `${PRODUCTION_HUB}/field-work`,
  '/field-operation': `${PRODUCTION_HUB}/field-work`,
  '/operation-tasks': `${PRODUCTION_HUB}/field-work`,
  '/field-task': `${PRODUCTION_HUB}/field-work`,
  '/nav_field_operations': `${PRODUCTION_HUB}/field-work`,
  '/sowing-management': `${PRODUCTION_HUB}/field-work/sowing`,
  '/fertilization-management': `${PRODUCTION_HUB}/field-work/fertilizing`,
  '/weeding-management': `${PRODUCTION_HUB}/field-work/weeding`,
  '/irrigation-management': `${PRODUCTION_HUB}/field-work/irrigation`,
  '/irrigation-plan-ledger': `${PRODUCTION_HUB}/field-work/irrigation?tab=ledger`,
  '/irrigation-design-management': `${PRODUCTION_HUB}/field-work/irrigation?tab=design`,
  '/disease-warning': `${PRODUCTION_HUB}/field-work/pest-control`,
  '/stage-protection-plan': `${PRODUCTION_HUB}/crop/planted`,
  '/warning-management': `${PRODUCTION_HUB}/field-work/warning-management`,
  '/environment-monitoring': `${PRODUCTION_HUB}/land/env-monitoring`,
  '/agricultural-materials': `${PRODUCTION_HUB}/support/agricultural-materials`,
  '/materials-info': `${PRODUCTION_HUB}/support/materials-info`,
  '/materials-management': `${PRODUCTION_HUB}/support/materials-management`,
  '/farm-procurement': `${PRODUCTION_HUB}/support/farm-procurement`,
  '/grain-storage': `${PRODUCTION_HUB}/support/grain-storage`,
  '/agricultural-material': `${PRODUCTION_HUB}/support/agricultural-material`,
  '/expert-advice': '/agri-news/expert-advice',
  '/seasonal-guidance': '/agri-news/seasonal-guidance',
  '/weather-data': '/weather-agronomy/weather-data',
  '/disaster-warning': '/weather-agronomy/disaster-warning',
  '/local-climate': '/weather-agronomy/local-climate',
  '/intervention-plans': '/weather-agronomy/intervention-plans',
  '/data-statistics': `${PRODUCTION_HUB}/land/business-analysis`,
  '/sales-statistics': `${PRODUCTION_HUB}/land/business-analysis`,
  '/economic-statistics': `${PRODUCTION_HUB}/land/business-analysis`,
  '/economic-analysis': `${PRODUCTION_HUB}/land/business-analysis`,
};

const MY_FARM_FIELD_WORK = {
  '/my-farm/farm-work-hub': `${PRODUCTION_HUB}/field-work/hub`,
  '/my-farm/pest-ecology': `${PRODUCTION_HUB}/field-work/pest-ecology`,
  '/my-farm/growth-yield-analysis': `${PRODUCTION_HUB}/crop/yield-analysis`,
  '/my-farm/scheme-hub': `${PRODUCTION_HUB}/crop/schemes`,
  '/my-farm/smart-farm-cockpit': '/smart-farm-cockpit',
  '/my-farm/smart-irrigation-hub': `${PRODUCTION_HUB}/field-work/irrigation`,
  '/my-farm/smart-device': `${PRODUCTION_HUB}/land/smart-device`,
  '/production/land/irrigation-network-analysis': `${PRODUCTION_HUB}/land/irrigation-network-analysis`,
};

const PARAM_PATTERNS = [
  {
    re: /^\/my-farm\/land-map\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/${id}/map`,
  },
  {
    re: /^\/my-farm\/land-dashboard\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/${id}/dashboard`,
  },
  {
    re: /^\/my-farm\/land-planting-archive\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/${id}/planting-archive`,
  },
  {
    re: /^\/my-farm\/land-soil-archive\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/${id}/soil-archive`,
  },
  {
    re: /^\/my-farm\/land-farming-history\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/${id}/farming-history`,
  },
  {
    re: /^\/my-farm\/land-field-ops\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/field-work/by-land/${id}`,
  },
  {
    re: /^\/my-farm\/land-media\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/${id}/media`,
  },
  {
    re: /^\/my-farm\/land-field-vision\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/${id}/media`,
  },
  {
    re: /^\/my-farm\/scheme-editor\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/scheme-editor/${id}`,
  },
  {
    re: /^\/my-farm\/scheme-export\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/scheme-export/${id}`,
  },
  {
    re: /^\/my-farm\/scheme-versions\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/scheme-versions/${id}`,
  },
  {
    re: /^\/land-detail\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/${id}`,
  },
  {
    re: /^\/irrigation-design-map\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/irrigation-design-map/${id}`,
  },
  {
    re: /^\/irrigation-design-rule-config\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/irrigation-design-rule-config/${id}`,
  },
  {
    re: /^\/irrigation-design-rotation-plan\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/irrigation-design-rotation-plan/${id}`,
  },
  // 微调编排已废弃：旧路径落到水肥作业方案页
  {
    re: /^\/irrigation-design-mode-config\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/irrigation-design-rotation-plan/${id}`,
  },
  {
    re: /^\/irrigation-design-bom\/([^/]+)$/,
    to: (id) => `${PRODUCTION_HUB}/land/irrigation-design-bom/${id}`,
  },
  {
    re: /^\/disease-warning\/(.+)$/,
    to: (rest) => `${PRODUCTION_HUB}/field-work/pest-control/${rest}`,
  },
  {
    re: /^\/production-planning\/(.+)$/,
    to: () => `${PRODUCTION_HUB}/crop/planted`,
  },
  {
    re: /^\/my-farm\/modules\/([^/]+)$/,
    to: (key) => `${PRODUCTION_HUB}/land/modules/${key}`,
  },
];

/**
 * 将 /my-plant-protection/* 旧路径映射为 canonical 路径（含 query 保留）
 */
export function mapLegacyProductionPath(pathname, search = '') {
  const pathOnly = pathname.split('?')[0];
  const query = search || (pathname.includes('?') ? `?${pathname.split('?')[1]}` : '');

  if (pathOnly === LEGACY_PRODUCTION_PREFIX || pathOnly === `${LEGACY_PRODUCTION_PREFIX}/`) {
    return PRODUCTION_HUB + query;
  }

  if (!pathOnly.startsWith(`${LEGACY_PRODUCTION_PREFIX}/`)) {
    return pathOnly + query;
  }

  const suffix = pathOnly.slice(LEGACY_PRODUCTION_PREFIX.length);

  if (EXACT_SUFFIX_MAP[suffix] !== undefined) {
    const mapped = EXACT_SUFFIX_MAP[suffix];
    if (mapped.includes('?')) {
      return mapped;
    }
    return mapped + query;
  }

  if (MY_FARM_FIELD_WORK[suffix] !== undefined) {
    return MY_FARM_FIELD_WORK[suffix] + query;
  }

  for (const { re, to } of PARAM_PATTERNS) {
    const m = suffix.match(re);
    if (m) {
      return to(m[1]) + query;
    }
  }

  if (suffix.startsWith('/my-farm/')) {
    return `${PRODUCTION_HUB}/land${suffix.slice('/my-farm'.length)}` + query;
  }

  return `${PRODUCTION_HUB}${suffix}` + query;
}

/** navigate/Link 用：已是新路径则原样返回 */
export function toProductionPath(path) {
  if (!path || typeof path !== 'string') return path;
  const [pathOnly, ...rest] = path.split('?');
  const query = rest.length ? `?${rest.join('?')}` : '';
  if (pathOnly.startsWith(PRODUCTION_HUB)) return path;
  if (pathOnly.startsWith(LEGACY_PRODUCTION_PREFIX)) {
    return mapLegacyProductionPath(pathOnly, query);
  }
  return path;
}
